import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

export class Imagepreview extends BlockEmbed {
  static create(value) {
    let node = super.create();
    node.setAttribute('contenteditable', false);
    const imgPreview = document.createElement('img');
    imgPreview.classList.add('img-preview');
    imgPreview.setAttribute('contenteditable', false);
    imgPreview.setAttribute('src', value);
    node.appendChild(imgPreview);
    return node;
  }

  static formats(node) {
    let format = {};
    format.uploaded = node.classList.contains('uploaded');
    format['loading-img'] = node.querySelector('img').classList.contains('loading-img');
    return format;
  }

  static value(domNode) {
    return domNode.querySelector('img').getAttribute('src');
  }

  format(name, value) {
    if (name === 'uploaded') {
      if (value) {
        this.domNode.classList.add('uploaded');
      } else {
        this.domNode.classList.remove('uploaded');
      }
    } else if (name === 'loading-img') {
      const imgPreview = this.domNode.querySelector('img');
      if (value) {
        imgPreview.classList.add('loading-img');
      } else {
        imgPreview.classList.remove('loading-img');
      }
    } else {
      super.format(name, value);
    }
  }
}
Imagepreview.blotName = 'imagepreview';
Imagepreview.tagName = 'div';
Imagepreview.className = 'ql-image-preview';

export default Imagepreview;
